export default "/assets/images/attic-video-thumbnail.be1867a598a2e132.jpg";